<template>
  <div class="contact">
    <div class="contact-header">
      <h1>联系我们</h1>
    </div>
    
    <div class="contact-content">
      <div class="contact-info">
        <h2>联系方式</h2>
        <div class="info-items">
          <div class="info-item">
            <i class="location-icon"></i>
            <div class="info-text">
                  <h3>公司地址</h3>
                  <p>{{ contactInfo.address }}</p>
            </div>
          </div>
          <div class="info-item">
            <i class="phone-icon"></i>
            <div class="info-text">
                  <h3>联系电话</h3>
                  <p>{{ contactInfo.phone }}</p>
            </div>
          </div>
          <div class="info-item">
            <i class="email-icon"></i>
            <div class="info-text">
                  <h3>电子邮箱</h3>
                  <p>{{ contactInfo.email }}</p>
            </div>
          </div>
        </div>
      </div>
      
      <div class="contact-form">
        <h2>在线留言</h2>
        <el-form 
          ref="formRef"
          :model="form" 
          :rules="rules" 
          label-position="top"
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name" placeholder="请输入您的姓名"></el-input>
          </el-form-item>
          
          <el-form-item label="电话" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入您的联系电话"></el-input>
          </el-form-item>
          
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="form.email" placeholder="请输入您的邮箱地址"></el-input>
          </el-form-item>
          
          <el-form-item label="留言内容" prop="message">
            <el-input 
              type="textarea" 
              v-model="form.message" 
              rows="4"
              placeholder="请输入您的留言内容"
            ></el-input>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" @click="submitForm" :loading="submitting">
              提交留言
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import request from '@/utils/request'
import { fetchContentByCode } from '@/utils/cms'

export default {
  name: 'Contact',
  setup() {
    const formRef = ref(null)
    const submitting = ref(false)
    const contactInfo = reactive({
      address: '北京市昌平区鼓楼南街6号8层',
      phone: '15711100050',
      email: 'info@xingxutech.com'
    })
    
    const form = ref({
      name: '',
      phone: '',
      email: '',
      message: ''
    })

    const rules = {
      name: [
        { required: true, message: '请输入姓名', trigger: 'blur' },
        { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
      ],
      phone: [
        { required: true, message: '请输入电话', trigger: 'blur' },
        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
      ],
      email: [
        { required: true, message: '请输入邮箱', trigger: 'blur' },
        { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
      ],
      message: [
        { required: true, message: '请输入留言内容', trigger: 'blur' },
        { min: 5, max: 500, message: '长度在 5 到 500 个字符', trigger: 'blur' }
      ]
    }

    const submitForm = async () => {
      if (!formRef.value) return
      
      try {
        await formRef.value.validate()
        submitting.value = true
        
        await request.post('/messages', form.value)
        ElMessage.success('提交成功，我们会尽快与您联系')
        
        // 重置表单
        form.value = {
          name: '',
          phone: '',
          email: '',
          message: ''
        }
        formRef.value.resetFields()
      } catch (error) {
        if (error.message) {
          ElMessage.error(error.message)
        } else {
          ElMessage.error('提交失败，请稍后重试')
        }
      } finally {
        submitting.value = false
      }
    }

    const loadContact = async () => {
      const address = await fetchContentByCode('contact_address')
      const phone = await fetchContentByCode('contact_phone')
      const email = await fetchContentByCode('contact_email')
      if (address?.content) contactInfo.address = address.content
      if (phone?.content) contactInfo.phone = phone.content
      if (email?.content) contactInfo.email = email.content
    }

    onMounted(loadContact)

    return {
      formRef,
      form,
      rules,
      submitting,
      submitForm,
      contactInfo
    }
  }
}
</script>

<style scoped>
.contact {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.contact-header {
  text-align: center;
  margin-bottom: 40px;
}

.contact-header h1 {
  font-size: 32px;
  color: #2c3e50;
  margin: 0;
}

.contact-content {
  display: flex;
  gap: 40px;
}

.contact-info, .contact-form {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
}

.contact-info h2, .contact-form h2 {
  font-size: 24px;
  color: #2c3e50;
  margin: 0 0 30px;
}

.info-items {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.info-item i {
  width: 24px;
  height: 24px;
  background-size: contain;
  background-repeat: no-repeat;
}

.location-icon {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%233498db' d='M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z'/%3E%3C/svg%3E");
}

.phone-icon {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%233498db' d='M6.62 10.79c1.44 2.83 3.76 5.15 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z'/%3E%3C/svg%3E");
}

.email-icon {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%233498db' d='M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z'/%3E%3C/svg%3E");
}

.info-text h3 {
  font-size: 16px;
  color: #2c3e50;
  margin: 0 0 5px;
}

.info-text p {
  font-size: 14px;
  color: #666;
  margin: 0;
}

:deep(.el-form-item__label) {
  padding: 0 0 8px;
  line-height: 1.5;
  font-size: 16px;
  color: #2c3e50;
}

:deep(.el-input__inner), :deep(.el-textarea__inner) {
  border-radius: 4px;
}

.el-button {
  width: 100%;
  margin-top: 10px;
  height: 44px;
  font-size: 16px;
}

@media (max-width: 768px) {
  .contact {
    padding: 20px 15px;
  }

  .contact-header {
    margin-bottom: 20px;
  }

  .contact-header h1 {
    font-size: 24px;
  }

  .contact-content {
    flex-direction: column;
    gap: 20px;
  }

  .contact-info, .contact-form {
    padding: 20px;
  }

  .contact-info h2, .contact-form h2 {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .info-items {
    gap: 15px;
  }

  .info-item {
    gap: 12px;
  }

  .info-text h3 {
    font-size: 15px;
  }

  .info-text p {
    font-size: 14px;
  }

  :deep(.el-form-item) {
    margin-bottom: 15px;
  }

  :deep(.el-form-item__label) {
    font-size: 15px;
    padding-bottom: 6px;
  }

  .el-button {
    height: 40px;
    font-size: 15px;
  }
}
</style> 